import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Headline as SecondaryHeadline,
  Summary as SecondarySummary,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { EntityLink } from "scmp-app/components/entity-link";

/* Text above image on mobile; image-first from tablet up (order flip). */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LeadImageLink = styled(EntityLink)`
  order: 2;

  display: block;

  ${theme.breakpoints.up("tablet")} {
    order: 1;
  }
`;

export const LeadCoverImage = styled(ContentCoverImage)``;

export const LeadText = styled.div`
  order: 1;

  ${theme.breakpoints.up("tablet")} {
    order: 2;
  }
`;

export const StyledLeadItem = styled(ContentItemHomeSecondaryV2)`
  ${SecondaryHeadline} {
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -0.36px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 20px;
      letter-spacing: -0.4px;
    }
  }

  ${SecondarySummary} {
    color: #5a5a5a;
    font-size: 14px;
    line-height: 135%;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;
